import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const TopBarLoader = ({ color = '#1e40af' }) => {
  const { pathname } = useLocation();
  const [animKey, setAnimKey] = useState(0);
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    clearTimeout(timerRef.current);
    setVisible(true);
    setAnimKey(k => k + 1);
    timerRef.current = setTimeout(() => setVisible(false), 700);
    return () => clearTimeout(timerRef.current);
  }, [pathname]);

  if (!visible) return null;

  return (
    <div
      key={animKey}
      className="top-bar-loader"
      style={{ '--bar-color': color }}
    />
  );
};

export default TopBarLoader;
